var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2099 4.8125L13.8682 14.4372L6.52576 24.0618H16.3155L23.6579 14.4372L30.9996 4.8125H21.2099Z",
    fill: "#009F75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5003 14.4375L22.842 24.0622H21.2102L13.8685 14.4375H15.5003Z",
    fill: "#03E287"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5792 14.4375L26.921 24.0622H25.29L17.9475 14.4375H19.5792Z",
    fill: "#03E287"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 24.0622H29.3691L22.0266 14.4375H23.6584L31.0001 24.0622Z",
    fill: "#03E287"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1314 0H7.34246L0 9.62466H5.91478L2.44724 23.2595L17.1314 4.01022H14.0727L17.1314 0Z",
    fill: "#03E287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.0ed09a924219c6972659158a93f281cc.svg";
export { ForwardRef as ReactComponent };